import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@app/store/store';
import { ReactNode } from 'react';

interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const isLoggedIn = useAppSelector((state) => state.auth.currentUser);
  
  console.log('PrivateRoute:', { isLoggedIn: !!isLoggedIn });
  
  if (!isLoggedIn) {
    return <Navigate to="/home" replace />;
  }
  
  return <>{children}</>;
};

export default PrivateRoute;